import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { AdvancedFilterSetting } from "event-definitions"
import { modelStats } from "routes/facilities/controller/model-stats"
import { findScheduleInStats } from "routes/facilities/plugins/profiles/findScheduleInStats"
import { findFolderInStats } from "routes/facilities/plugins/profiles/folderCompleteness"

export async function filterRegime({ schedules, context: { parentItem } }) {
    if (!parentFind(parentItem, (c) => c[PlanRoot])) return { schedules }

    const filters = AdvancedFilterSetting.filters()
    if (filters.length === 0) return undefined

    const stats = await modelStats(parentItem.id)
    if (!stats?.stats) return { schedules }

    const groups = filters.groupBy("type")
    for (const [type, list] of Object.entries(groups)) {
        schedules = schedules.filter((row) => rowMatches(row, type, list))
    }

    return { schedules }

    function rowMatches(row, type, list) {
        if (row.type === "schedule") {
            const profile = findScheduleInStats(stats, row)
            if (!profile) return true
            return list.some((filter) => scheduleMatches(profile, type, filter))
        }
        const folder = findFolderInStats(stats, row)
        if (!folder) return true
        return list.some((filter) => groupMatches(folder, type, filter))
    }

    function scheduleMatches(profile, type, filter) {
        switch (type) {
            case "period":
                return (profile.periods ?? []).some((p) => p.frequency === filter.period?.frequency)
            case "skill":
                return (profile.skills ?? []).some((s) => s.skill === filter.skill?.skill)
            case "criticality":
                return (profile.total ?? []).some((t) => t.classification === filter.criticality)
            default:
                return true
        }
    }

    function groupMatches(folder, type, filter) {
        switch (type) {
            case "period":
                return (folder.allPeriods ?? []).some((p) => p.frequency === filter.period?.frequency)
            case "skill":
                return (folder.allSkills ?? []).some((s) => s.skill === filter.skill?.skill)
            case "criticality":
                return (folder.total ?? []).some((t) => t.classification === filter.criticality)
            default:
                return true
        }
    }
}
